export const authEndpoint = `${process.env.REACT_APP_API}/api/auth`;
export const resourceEndpoint = `${process.env.REACT_APP_API}/api`;